import { Box, Divider, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { InviteCardProps } from "../types";
import { useSnapshot } from "valtio";
import { editorState } from "../../../../utils/editor";
import { differenceInDays } from "../../../../utils/difference.in.days";
import { userStore } from "../../../../hooks/store";
import { getCoupleDisplayName } from "../../../../utils/couple.names";

const CountdownSample: React.FC<InviteCardProps> = ({
  w,
  h,
  px,
  venueSize,
  border,
}) => {
  const { mainContent, groomFirstName, brideFirstName } =
    useSnapshot(editorState);
  const { data: loggedInUser } = useSnapshot(userStore);

  // console.log(mainContent.date);
  const daysLeft = differenceInDays(mainContent.date);
  return (
    <Flex
      flexDir={"column"}
      bg={"#fff"}
      fontFamily={"font4"}
      py={"9.8px"}
      px={px ?? "24px"}
      border={border ?? "1px solid #00000033"}
      w={w ?? "full"}
      h={h ?? "full"}
      maxW={"398px"}
      maxH={"600px"}
      minH={"450px"}
      alignItems={"center"}
    >
      <Box
        bg={"#f9f9f9"}
        borderRadius={"18.59px"}
        fontFamily={"font4"}
        py={"7.5px"}
        px={"14.7px"}
        mb={"5px"}
      >
        <Text fontSize={"9.96px"} textTransform={"uppercase"}>
          {mainContent.hashtag}❤️
        </Text>
      </Box>
      <Divider bg={"#00000030"} orientation="horizontal" />
      <Image
        src="/images/ring-yellow.png"
        mt={"1rem"}
        borderRadius={"1rem"}
        h={"100px"}
        objectFit={"cover"}
        w={"100%"}
      />
      <Text
        fontFamily={"font4"}
        fontSize={"16px"}
        fontWeight={600}
        py={"10px"}
        textAlign={"center"}
      >
        Just {daysLeft} Day{daysLeft > 1 || daysLeft < 1 ? "s" : ""} to our big
        day
      </Text>

      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        // textTransform={"uppercase"}
        textAlign={"center"}
        pb={"10px"}
      >
        Dear {loggedInUser.firstname},
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        // textTransform={"uppercase"}
        textAlign={"center"}
        pb={"10px"}
      >
        Can you believe it? In just {daysLeft} day
        {daysLeft > 1 || daysLeft < 1 ? "s" : ""}, we’ll be saying "I do"! We’re
        counting down the days and are so thrilled that you’ll be there to share
        in our joy.
      </Text>
      <Text fontFamily={"font4"} fontSize={"11px"} textAlign={"center"}>
        Your presence means the world to us, and we can’t wait to create
        beautiful memories together.
      </Text>
      {/* <Text
        fontFamily={"font4"}
        fontSize={venueSize ?? "11px"}
        textAlign={"center"}
        pt={"11px"}
      >
        We’re so excited to see you soon!
      </Text> */}
      <Text
        fontFamily={"font4"}
        fontSize={"12.96px"}
        textAlign={"center"}
        pt={"10px"}
      >
        With love and warmest wishes,
      </Text>

      <Text
        fontFamily={"font4"}
        fontSize={"12px"}
        fontWeight={600}
        textAlign={"center"}
        w={"151.26px"}
        pb={"10px"}
      >
        {getCoupleDisplayName({
          brideFirstName,
          groomFirstName,
          coupleNameOrder: editorState.coupleNameOrder,
        })} ❤️
      </Text>
      <Flex
        bg={"#000"}
        borderRadius={"29.41px"}
        w={"195.2px"}
        py={"11px"}
        justifyContent={"center"}
        alignItems={"center"}
        fontSize={"0.765rem"}
        fontFamily={"font4"}
        textTransform={"uppercase"}
        letterSpacing={"1px"}
        fontWeight={600}
        color={"#fff"}
      >
        This is a sample
      </Flex>
    </Flex>
  );
};
export default CountdownSample;
